export type ServiceBookingStatus = 'PendingPayment' | 'Confirmed' | 'Cancelled' | 'Completed' | 'NoShow';

export interface ServiceBookingOperatingHour {
    dayOfWeek: number;
    opensAt: string;
    closesAt: string;
    isClosed: boolean;
}

export interface ServiceBookingLocationSettings {
    id: number;
    name: string;
    address: string;
    timeZoneId: string;
    slotIntervalMinutes: number;
    capacity: number;
    isActive: boolean;
    operatingHours: ServiceBookingOperatingHour[];
}

export interface ServiceBookingOfferingSettings {
    id: number;
    serviceId: number;
    name: string;
    description: string;
    machineCategoryKey: string;
    durationMinutes: number;
    laborPrice: number;
    depositAmount: number;
    depositShopifyVariantId?: number | null;
    isActive: boolean;
    displayOrder: number;
}

export interface ServiceBookingMachineRule {
    id: number;
    name: string;
    machineCategoryKey: string;
    criteria: Record<string, string>;
    priority: number;
    isActive: boolean;
}

export interface ServiceBookingSettings {
    isEnabled: boolean;
    customerIntroText: string;
    defaultMachineCategoryKey: string;
    pendingPaymentHoldMinutes: number;
    location: ServiceBookingLocationSettings;
    offerings: ServiceBookingOfferingSettings[];
    machineRules: ServiceBookingMachineRule[];
}

export interface ServiceBookingAppointment {
    id: number;
    publicId: string;
    status: ServiceBookingStatus;
    startsAtUtc: string;
    endsAtUtc: string;
    startsAtLocal: string;
    endsAtLocal: string;
    locationName: string;
    serviceName: string;
    vehicleLabel: string;
    machineCategoryKey: string;
    laborPrice: number;
    depositAmount: number;
    customerName: string;
    customerEmail: string;
    customerPhone: string;
    customerNotes: string;
    productTitle: string;
    productSku: string;
    shopifyOrderId?: number | null;
    shopifyOrderName: string;
    createdAt: string;
}

export interface ServiceBookingCalendar {
    date: string;
    locationName: string;
    timeZoneId: string;
    appointments: ServiceBookingAppointment[];
}

export interface ServiceBookingAppointmentList {
    locationName: string;
    timeZoneId: string;
    totalCount: number;
    appointments: ServiceBookingAppointment[];
}

export interface ServiceBookingPaymentReconciliation {
    paidOrdersChecked: number;
    appointmentsConfirmed: number;
}

export const createOffering = (displayOrder: number): ServiceBookingOfferingSettings => ({
    id: 0,
    serviceId: 0,
    name: 'New service',
    description: '',
    machineCategoryKey: '*',
    durationMinutes: 30,
    laborPrice: 0,
    depositAmount: 30,
    depositShopifyVariantId: null,
    isActive: true,
    displayOrder,
});

export const createMachineRule = (priority: number): ServiceBookingMachineRule => ({
    id: 0,
    name: 'New machine rule',
    machineCategoryKey: 'standard',
    criteria: { year: '', make: '', model: '', submodel: '' },
    priority,
    isActive: true,
});
